import { useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { selectSimilarProducts } from '@client/product/redux/similarProducts/redux';
import { ProductTileType } from 'b2b-common/core/product/api/ProductTile.types';

export const useSimilarProducts = (): RemoteRecord<Record<string, ProductTileType>> => (
  useSelector(selectSimilarProducts)
);
